import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class ExternalPackagingService extends Service {
	constructor(injector: Injector) {
		super("ExternalPackaging", injector);
	}
}